"use strict";

exports.__esModule = true;
exports.formatDate = formatDate;
var _Time = require("../../../Time");
/**
 * For the data value apply the formatting preferences to the value
 */
function formatDate(rawValue, columnSettings, time) {
  if (new Date(rawValue).toString() === "Invalid Date") {
    return rawValue;
  }
  var formatOptions = columnSettings.dateFormat ? _Time.DATE_PRESETS[columnSettings.dateFormat] : _Time.DATE_PRESETS.LongDateTime;

  /* Note: createdMillis is used only for comments and the below change acts as usePlantTime: true */
  if (columnSettings.usePlantTime || columnSettings.id === "createdMillis") {
    return (0, _Time.formatDateString)(rawValue, Object.assign({}, formatOptions, {
      timeZone: time.timezone.name
    }));
  }
  return (0, _Time.formatDateString)(rawValue, formatOptions);
}